import React, { FunctionComponent } from "react";
import { Field, useFormState } from "react-final-form";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import BootstrapInput from "../../../components/BootstrapInput";
import Button from "../../../components/Button";

const useStyles = makeStyles(() => ({
  root: {
    padding: "24px 16px",
    borderRadius: 15,
    backgroundColor: "#ffffff",
    boxShadow: "0 0 8px #C2C9D682",
    top: 119,
    position: "sticky",
  },
  container: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#231F20",
    lineHeight: "29px",
  },
  mainContainer: {
    marginTop: 12,
  },
  formControl: {
    marginTop: 26,
  },
}));

const ContentForm: FunctionComponent = () => {
  const classes = useStyles();
  const {
    values: {
      subscribers = [],
      students = [],
      parents = [],
      agents = [],
      schoolUsers = [],
      serviceProviderUsers = [],
    },
  } = useFormState();

  const selectedUsersCount =
    subscribers.length +
    students.length +
    parents.length +
    agents.length +
    schoolUsers.length +
    serviceProviderUsers.length;

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography className={classes.title} component={"h2"}>
          Compose Email
        </Typography>
      </div>
      <div className={classes.mainContainer}>
        <div>
          <Field
            fullWidth
            required
            type="text"
            label="Subject"
            placeholder="Subject"
            name="subject"
            component={BootstrapInput}
          />
        </div>
        <div className={classes.formControl}>
          <Field
            fullWidth
            required
            type="text"
            label="Title"
            placeholder="Title"
            name="title"
            component={BootstrapInput}
          />
        </div>
        <div className={classes.formControl}>
          <Field
            rows={4}
            required
            multiline
            fullWidth
            type="textarea"
            label="Content"
            name="content"
            placeholder="Content"
            component={BootstrapInput}
          />
        </div>
        <div className={classes.formControl}>
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            disabled={selectedUsersCount === 0}
            fullWidth
          >
            Broadcast to {selectedUsersCount} user
            {selectedUsersCount === 1 ? "" : "s"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ContentForm);
